<template>
  <div class="modal-header">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ModelHeader'
}
</script>

